import React, { Component, Fragment } from "react";
import { Row, Col, Container, Image } from "react-bootstrap";

import styles from "./ContactInfo.module.scss";

import LinkedIn from "../../assets/png/LinkedIn.png";
import Twitter from "../../assets/png/Twitter.png";
import Facebook from "../../assets/png/Facebook.png";
import Instagram from "../../assets/png/Instagram.png";
import Email from "../../assets/png/Email.png";
import Phone from "../../assets/png/Phone.png";
import Mail from "../../assets/png/Mail.png";
import GetInTouch from "../../assets/png/GetInTouch.png";
import ContactImg from "../../assets/jpg/ContactPage.jpg";

export default class ContactInfo extends Component {
  render() {
    return (
      <section id={styles.ContactInfo}>
        <Container id="Social" fluid>
          <Row>
            <Col lg={6} id={styles.Box1}>
              <Image src={ContactImg} id={styles.ContactImg}></Image>
              <Image src={GetInTouch} id={styles.GetInTouch}></Image>
            </Col>

            <Col lg={6} id={styles.Box2}>
              <p id={styles.Header}>
                Curbside pickup and delivery options available.
              </p>
              <br></br>

              <Image src={Mail} id={styles.Mail} />
              <span>
                <div id={styles.Address}>
                  2515 Bank Street <br></br> P.O. Box 40152 <br></br> Ottawa,
                  Ontario, Canada <br></br> K1V 0W8
                </div>
              </span>
              <br></br>

              <Image src={Phone} id={styles.Phone} />
              <span>
                <div id={styles.PhoneNumber}>(613) 262-3704</div>
              </span>
              <br></br>

              <Image src={Email} id={styles.Email} />
              <span>
                <a
                  id={styles.InfoEmail}
                  href={"mailto:" + `info@agrinolinc.com`}
                >
                  info@agrinolinc.com
                </a>
              </span>
              <br></br>

              <p id={styles.EndText}>
                <i>
                  We love hearing from our users!<br></br>Connect with us on
                  social media to share your feedback and thoughts.
                </i>
              </p>
              <br></br>
              <span id={styles.IconSpan}>
                <a href={`https://www.instagram.com/agrinolinc/`}>
                  <Image src={Instagram} id={styles.Instagram} />
                </a>
                <a href={`https://www.facebook.com/agrinolinc`}>
                  <Image src={Facebook} id={styles.Facebook} />
                </a>

                <a href={`https://twitter.com/agrinolinc`}>
                  <Image src={Twitter} id={styles.Twitter} />
                </a>

                <a href={`https://www.linkedin.com/company/agrinol-inc/`}>
                  <Image src={LinkedIn} id={styles.LinkedIn} />
                </a>
              </span>
              <div className={styles.vl}></div>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
